export default __webpack_public_path__ + "static/media/tolu.e9762c0c.jpg";